"use strict";
'use client';
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLastWinnersFlexInterval = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
// import { useMutation,useQuery } from '../useMutation';
var axios_1 = __importDefault(require("axios"));
var swr_1 = require("swr");
var balance_1 = require("../balance");
var countries_1 = require("../countries");
var geo_1 = require("../geo");
var user_1 = require("../user");
var useConfig_1 = require("../useConfig");
var SUCCESS_INTERVAL = 4000;
var ERROR_INTERVAL = 30000;
var DEFAULT_LIMIT = 30;
var useLastWinnersFlexInterval = function () {
    var _a, _b, _c;
    var config = (0, useConfig_1.useConfig)();
    var lastWinnersConfig = config === null || config === void 0 ? void 0 : config.lastWinners;
    var useAccountCurrencyForAuth = Boolean(lastWinnersConfig === null || lastWinnersConfig === void 0 ? void 0 : lastWinnersConfig.useAccountCurrencyForAuth);
    var isAuth = (0, user_1.useIsAuthorized)();
    var balanceData = (0, balance_1.useBalance)().data;
    var countriesData = (0, countries_1.useCountries)().data;
    var geoData = (0, geo_1.useGeo)().data;
    var _d = (0, swr_1.useSWRConfig)(), cache = _d.cache, mutate = _d.mutate;
    var cachedWinners = ((_a = cache.get(keys_1.LAST_WINNERS)) === null || _a === void 0 ? void 0 : _a.data) || [];
    var _e = (0, react_1.useState)(cachedWinners), preparedData = _e[0], setPreparedData = _e[1];
    var lastWinnerDate = (0, react_1.useRef)(((_b = cachedWinners === null || cachedWinners === void 0 ? void 0 : cachedWinners[0]) === null || _b === void 0 ? void 0 : _b.createdAt) || null);
    var intervalTime = (0, react_1.useRef)(SUCCESS_INTERVAL);
    var currentInterval = (0, react_1.useRef)(null);
    var countryCode = ((_c = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _c === void 0 ? void 0 : _c.countryCode) || null;
    var accountCurrency = (balanceData === null || balanceData === void 0 ? void 0 : balanceData.currency) || null;
    var allowedCurrenciesByCountry = lastWinnersConfig === null || lastWinnersConfig === void 0 ? void 0 : lastWinnersConfig.allowedCurrenciesByCountry;
    var geoCurrency = (0, react_1.useMemo)(function () {
        if (!countryCode || !(countriesData === null || countriesData === void 0 ? void 0 : countriesData.length))
            return null;
        var currentCountry = countriesData.find(function (country) { return country.code === countryCode; });
        return (currentCountry === null || currentCountry === void 0 ? void 0 : currentCountry.currencyCode) || null;
    }, [countriesData, countryCode]);
    var allowedCurrencies = (0, react_1.useMemo)(function () {
        var _a, _b, _c, _d;
        if (useAccountCurrencyForAuth) {
            if (isAuth)
                return accountCurrency ? [accountCurrency] : [];
            if (countryCode && ((_a = allowedCurrenciesByCountry === null || allowedCurrenciesByCountry === void 0 ? void 0 : allowedCurrenciesByCountry[countryCode]) === null || _a === void 0 ? void 0 : _a.length)) {
                return allowedCurrenciesByCountry[countryCode];
            }
            if (geoCurrency)
                return [geoCurrency];
            if ((_b = allowedCurrenciesByCountry === null || allowedCurrenciesByCountry === void 0 ? void 0 : allowedCurrenciesByCountry.__DEFAULT) === null || _b === void 0 ? void 0 : _b.length) {
                return allowedCurrenciesByCountry.__DEFAULT;
            }
            return [];
        }
        if (!allowedCurrenciesByCountry)
            return [];
        if (countryCode && ((_c = allowedCurrenciesByCountry === null || allowedCurrenciesByCountry === void 0 ? void 0 : allowedCurrenciesByCountry[countryCode]) === null || _c === void 0 ? void 0 : _c.length)) {
            return allowedCurrenciesByCountry[countryCode];
        }
        if ((_d = allowedCurrenciesByCountry === null || allowedCurrenciesByCountry === void 0 ? void 0 : allowedCurrenciesByCountry.__DEFAULT) === null || _d === void 0 ? void 0 : _d.length) {
            return allowedCurrenciesByCountry.__DEFAULT;
        }
        return [];
    }, [
        accountCurrency,
        allowedCurrenciesByCountry,
        countryCode,
        geoCurrency,
        isAuth,
        useAccountCurrencyForAuth,
    ]);
    var allowedCurrenciesKey = (0, react_1.useMemo)(function () {
        return allowedCurrencies.slice().sort().join('|');
    }, [allowedCurrencies]);
    var lastAllowedCurrenciesKey = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (!useAccountCurrencyForAuth)
            return;
        if (!allowedCurrencies.length) {
            lastAllowedCurrenciesKey.current = null;
            if (preparedData.length) {
                lastWinnerDate.current = null;
                setPreparedData([]);
                mutate(keys_1.LAST_WINNERS, [], false);
            }
            return;
        }
        if (lastAllowedCurrenciesKey.current === allowedCurrenciesKey)
            return;
        lastAllowedCurrenciesKey.current = allowedCurrenciesKey;
        lastWinnerDate.current = null;
        setPreparedData([]);
        mutate(keys_1.LAST_WINNERS, [], false);
    }, [
        allowedCurrencies.length,
        allowedCurrenciesKey,
        mutate,
        preparedData.length,
        useAccountCurrencyForAuth,
    ]);
    var shouldWaitForCurrency = useAccountCurrencyForAuth
        ? allowedCurrencies.length === 0
        : Boolean(allowedCurrenciesByCountry && !countryCode);
    (0, react_1.useEffect)(function () {
        if (shouldWaitForCurrency)
            return;
        function dedupeById(arr) {
            var seen = new Set();
            var out = [];
            for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
                var item = arr_1[_i];
                if (!item)
                    continue;
                if (!seen.has(item.id)) {
                    seen.add(item.id);
                    out.push(item);
                }
            }
            return out;
        }
        currentInterval.current = setInterval(function () { return __awaiter(void 0, void 0, void 0, function () {
            var input, res, newWinner, existedData, updatedWinners, dedupedWinners, err_1;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        _k.trys.push([0, 2, , 3]);
                        input = {};
                        if (allowedCurrencies.length)
                            input.currencies = allowedCurrencies;
                        if (lastWinnerDate.current)
                            input.dateFrom = lastWinnerDate.current;
                        return [4 /*yield*/, axios_1.default.post("".concat(window.location.origin).concat(keys_1.LAST_WINNERS), { input: input, useAccountCurrencyForAuth: useAccountCurrencyForAuth })];
                    case 1:
                        res = _k.sent();
                        if (intervalTime.current !== SUCCESS_INTERVAL)
                            intervalTime.current = SUCCESS_INTERVAL;
                        newWinner = (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.edges) === null || _b === void 0 ? void 0 : _b[0];
                        if ((_d = (_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.edges) === null || _d === void 0 ? void 0 : _d[0])
                            lastWinnerDate.current = newWinner === null || newWinner === void 0 ? void 0 : newWinner.createdAt;
                        if (((_e = res === null || res === void 0 ? void 0 : res.data) === null || _e === void 0 ? void 0 : _e.edges) && ((_g = (_f = res === null || res === void 0 ? void 0 : res.data) === null || _f === void 0 ? void 0 : _f.edges) === null || _g === void 0 ? void 0 : _g.length) > 0) {
                            existedData = preparedData || [];
                            updatedWinners = (_j = __spreadArray(__spreadArray([], ((existedData === null || existedData === void 0 ? void 0 : existedData.length) === 0 ? (_h = res === null || res === void 0 ? void 0 : res.data) === null || _h === void 0 ? void 0 : _h.edges : [newWinner]), true), existedData, true)) === null || _j === void 0 ? void 0 : _j.slice(0, DEFAULT_LIMIT);
                            dedupedWinners = dedupeById(updatedWinners);
                            setPreparedData(dedupedWinners);
                            mutate(keys_1.LAST_WINNERS, dedupedWinners, false);
                        }
                        if (intervalTime.current != SUCCESS_INTERVAL)
                            intervalTime.current = SUCCESS_INTERVAL;
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _k.sent();
                        clearInterval(currentInterval.current);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); }, intervalTime.current);
        return function () {
            clearInterval(currentInterval.current);
        };
    }, [preparedData, mutate, allowedCurrencies, shouldWaitForCurrency]);
    return (0, react_1.useMemo)(function () {
        return { data: preparedData };
    }, [preparedData]);
};
exports.useLastWinnersFlexInterval = useLastWinnersFlexInterval;
